import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/exclamation_mark.svg'


const _hoisted_1 = { class: "payment-errors error-message" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("img", { src: _imports_0 }, null, -1)),
    _createTextVNode(" " + _toDisplayString(_ctx.message), 1)
  ]))
}